import {Component, Output,EventEmitter , ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';
import 'rxjs/add/operator/filter';
import {MenuItems} from '../../shared/menu-items/menu-items';
import { Router } from '@angular/router';
import { User } from '../../shared/user/user.model';
import { NotificationService } from '../../services/notification.service';
import * as io from 'socket.io-client';
import * as Rx from "rxjs";
import { environment } from "../../../environments/environment";
import { FormBuilder, FormGroup } from '@angular/forms';
import { SoundNotificaionsService } from '../../services/sound-notificaions.service';
import { soundNotifications } from '../../shared/sound-notifications/soundNotifications';
import { UserService } from '../../services/user.service';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class AdminComponent implements OnInit {
  soundNotificationsList: [soundNotifications];
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  toggleOn = true;
  windowWidth: number;
  user: User = new User();
  loggedOnUser;
  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;

  //formChangeAudio: FormGroup;

  config: any;

  private socket;
  ioConnection: any;
  notifications: any = [];
  lista:string[] = ["normal","Show me the money"];

  // tslint:disable-next-line: max-line-length
  constructor(public menuItems: MenuItems, private router: Router, private notificationService: NotificationService, public formBuild: FormBuilder, private serviceSoundNotification: SoundNotificaionsService, private userService: UserService) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
    //this.builFormChangeAudio();
  }


  
  /*builFormChangeAudio() {
    this.formChangeAudio = this.formBuild.group({
      soundNotif: ['']
    });
  }*/

  public grupoNotifTmp = [];

  ngOnInit() {
    this.connect();
    if (localStorage.getItem('user') !== null) {
      this.loggedOnUser = JSON.parse(localStorage.getItem('user'));
    let users=JSON.parse(localStorage.getItem('user'));
    let id= users.data.id;
    
    console.log('iniciar notificacion')
     this.notificationService.getNotificationByUser(id)
     .subscribe((response:any) => {
       this.notifications=response.data;

       for(var json in this.notifications){
         let notiTmo = {}
         let arrayNotiTmp = []
         
         for(let j in this.notifications[json]){
          arrayNotiTmp.push(this.notifications[json][j])
         }
         notiTmo["groupName"] = json
         notiTmo["data"] = arrayNotiTmp
         this.grupoNotifTmp.push(notiTmo)

       }

       this.serviceSoundNotification.getAll().subscribe((res: any) => {
        
         this.soundNotificationsList = res.data;
         
       });

       console.log("Notifications en grupos son estos: ", this.grupoNotifTmp)
       
      

     });
  
  
      console.log(this.notifications);

      this.user.email = this.loggedOnUser.data.email;
      this.user.firstName = this.loggedOnUser.data.firstName;
      this.user.lastName = this.loggedOnUser.data.lastName;
      this.user.phone = this.loggedOnUser.data.phone;
      this.user.role = this.loggedOnUser.data.role;

    }
  }

  connect(): Rx.Subject<MessageEvent> {
    this.socket = io(environment.baseUrl, {path: environment.socketPath});
    let user = localStorage.getItem("user");

    this.socket.emit("new user", user);
		this.socket.on('notification', (data: any) => {
      this.playAudio();

      

      let notif = {
        groupName: data.nameForm,
        data: [data]
      }

      console.log('La notificaiones llegada en notificaciones es: ', notif);

      this.grupoNotifTmp.push(notif);
      
      // this.notifications = this.notifications.sort(function (a, b){
      //   if ( a.form_id < b.form_id )
      //     return -1;
      //     if ( a.form_id > b.form_id )
      //       return 1;
      //     return 0;
      // })


    })

		this.socket.on('connect', function () {
      console.log('Connected');
      
		});

    this.socket.on('disconnect', function () {
      console.log('Disconnected');
    });
		
		// We define our Observer which will listen to messages
		// from our other components and send messages back to our
		// socket server whenever the `next()` method is called.
		let observer = {
			next: (data: Object) => {
				this.socket.emit('message', JSON.stringify(data));
			},
		};

		// we return our Rx.Subject which is a combination
		// of both an observer and observable.
		return Rx.Subject.create(observer);
  }
  
  playAudio(){
    let audio = new Audio();
    let soundNotif = localStorage.getItem('urlAudio');
    audio.src = soundNotif;
    audio.load();
    audio.play();
  }

  logout() {
    localStorage.clear();
    setTimeout(() => {
      this.router.navigate(['/auth/login']);
    }, 1000);
  }

  checkAuth(roles: any) {
    let isMatch = false;

    roles.forEach(element => {
      if (element == this.user.role) {
        isMatch = true;
        return false;
      }
    });
    
    return isMatch;
  }

  onClickedOutside(e: Event) {
    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    }
  }
  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onScroll(event) {
    this.isScrolled = false;
  }
  update(usreId: string, formId: string) 
  {
   console.log("--> El user id del usuario es: " , usreId, " y el form id es: ", formId )
    const body = {
      user: usreId,
      formId: formId,
			status: "active",
			}
    this.notificationService.update(body)
    .subscribe((response:any) => {
         console.log("--> se actualizó", response.notifiaction);
         let users=JSON.parse(localStorage.getItem('user'));
       let idu= users.data.id;
       this.notificationService.getNotificationByUser(idu)
       .subscribe((response:any) => {
         this.grupoNotifTmp = []
         this.notifications=response.data;
         console.log("Nuevas notificaciones: ", response.data)


         for(var json in this.notifications){
          let notiTmo = {}
          let arrayNotiTmp = []
          
          for(let j in this.notifications[json]){
           arrayNotiTmp.push(this.notifications[json][j])
          }
          notiTmo["groupName"] = json
          notiTmo["data"] = arrayNotiTmp
          this.grupoNotifTmp.push(notiTmo)
 
        }
 
        console.log("Notifications en grupos son estos: ", this.grupoNotifTmp)


       });
       });     
    
  }

  changeAudio(Sound_id: any) {
  
    //console.log("Hollaaa===", bodySound);
    //let strNameSound = bodySound;
    //console.log("El sonido leccionado es: ", strNameSound.soundNotif);
    
    let users=JSON.parse(localStorage.getItem('user'));
    let idu= users.data.id;
    //let strUrlSound = strNameSound.soundNotif._id;
  
    let body ={
      _id : Sound_id,
      user_id :idu
    
    }

    /*this.soundNotifications.update(body).subscribe((res:any) => {
      console.log(res);
    });*/

    this.userService.updateSoundNotificationUsers(body).subscribe((res: any) => {
      localStorage.setItem('urlAudio', res.data.url);
    })
  }

  
 
}



// WEBPACK FOOTER //
// ./src/app/layouts/admin/admin.component.ts